import * as Sentry from '@sentry/react';

// Errors to ignore — browser noise, extensions, bots
const IGNORED_ERRORS = [
  // Browser/network noise
  'ResizeObserver loop',
  'ResizeObserver loop completed with undelivered notifications',
  'Non-Error promise rejection captured',
  'Load failed',
  'Failed to fetch',
  'NetworkError',
  'AbortError',
  'TypeError: cancelled',
  'TypeError: Cancelled',
  // Browser extensions
  'chrome-extension://',
  'moz-extension://',
  'safari-extension://',
  // Common harmless errors
  'Script error.',
  'ChunkLoadError',
];

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // Performance: sample 5% in production (low volume = low cost)
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.05 : 1.0,

  // Session Replay: 1% of sessions, 100% on error
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,

  // Only capture errors from your own code
  allowUrls: [
    /https?:\/\/(.*\.)?kulalearn\.com/,
    /https?:\/\/(.*\.)?vercel\.app/,
    /https?:\/\/localhost/,
  ],

  // Filter out noise before it counts against your quota
  ignoreErrors: IGNORED_ERRORS,

  beforeSend(event) {
    // Drop errors from browser extensions
    const frames = event.exception?.values?.[0]?.stacktrace?.frames;
    if (frames?.some(f => f.filename?.includes('extension://'))) {
      return null;
    }
    return event;
  },
});

export default Sentry;
